var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message__block message__block--multimedia",attrs:{"role":"button"},on:{"click":_vm.openImage}},[_c('img',{staticClass:"message__block-content",attrs:{"src":_vm.previewUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }